import { Head } from "@inertiajs/react";
import MainLayout from "../../components/MainLayout";
import Container from "../../components/Container";

import { StoreSettings, ExclusiveProduct } from "../../types";

interface BlogProps {
  store_settings: StoreSettings;
  exclusive_products: ExclusiveProduct[];
}

const Blog = ({ store_settings, exclusive_products }: BlogProps) => {
  return (
    <MainLayout
      store_settings={store_settings}
      exclusiveProducts={exclusive_products}
    >
      <Head title="Blog" />
      <main>
        <Container>
          <div className="py-12">
            <h1 className="text-4xl font-bold">Blog</h1>
            <p className="mt-4 text-lg">
              Aquí se mostrarán las entradas del blog.
            </p>
          </div>
        </Container>
      </main>
    </MainLayout>
  );
};

export default Blog;
